<template>
  <section>
    <div :key="boardData.id + '-name'" class="mdc-card mgb-24 cursor-pointer">
      <div>
        <div class="pdl-24 pdr-24 pdt-24" @click="moveToDetail(boardData.id)" @keypress="moveToDetail(boardData.id)" tabindex="0" :class="{'bg-documentGray': boardData.isBlocked}">
          <div class="attach-pin position-absolute cursor-pointer" tabindex="0" v-show="type !== 'MINE' && boardData.fixed">
            <img alt="" class="w-29 h-29" src="/images/board/attach-pin.svg">
          </div>
          <div class="d-flex">
            <UserImgProfile :allData="boardData" :data="boardData.auditor.register" :className="'mgr-0'" />
            
            <div class="flex-grow-1 pdl-16">
              <div class="d-flex justify-content-between">
                <div
                    v-if="boardData.auditor && boardData.auditor.register && boardData.auditor.register && boardData.auditor.register.name"
                    class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': boardData.isBlocked}">{{
                    boardData.auditor.register.name ? $t('3437', {
                      first: boardData.auditor.register.name.first,
                      last: boardData.auditor.register.name.last
                    }) : ''
                  }}
                </div>
              </div>
              <div class="d-flex user-list-info">
                <div v-if="boardData.auditor && boardData.auditor.register && boardData.auditor.register.time"
                     class="t-body3 t-color-bodyGrayA font-r" :class="{'t-color-bodyGrayB': boardData.isBlocked}">
                  {{ $moment(boardData.auditor.register.time).format('L') }}
                </div>
                <div v-else class="t-body3 t-color-bodyGrayA font-r"></div>
              </div>
            </div>
          </div>
          <div class="t-subtitle3 font-r t-line-1 mgt-16 l-spacing48 t-line-h-25 cursor-pointer" :class="{'t-color-bodyGrayB': boardData.isBlocked}">
            {{ boardData.isBlocked ? $t("3814") : boardData.contents ? boardData.contents.subject : '' }}
          </div>
          
	        <div class="t-body6 font-r t-color-bodyGrayA mgt-8 l-spacing45 t-line-h-25 t-preline ql-container">
		        <div class="t-line-4" v-if="!boardData.isBlocked"
		             v-html="contentsRemoveTag(boardData.contents.body)">
		        </div>
	        </div>
	        
	        
          <swiper v-show="!boardData.isBlocked && isMediaFile.length > 0" ref="mySwiper" :options="swiperOption" class="mgt-16 mgb-16 single-slide position-relative slider-video-center">
            <swiper-slide v-for="(imageVideo, k) in isMediaFile" :key="k" class="">
              <div ref="imageVideoRef"
                   :class="getType(imageVideo.contentType) === 'image' ? 'square-image' : ''"
                   class="mgb-6 swiper-slide position-relative wiperSlideWrapper bg-white cursor-pointer " >
                <img v-if="getType(imageVideo.contentType) === 'image'"
                     :src="imageVideo.resourceUri"
                     alt="" class="board-list-image"
                >
                <div v-else
                     @click.stop
                     @keypress.stop>
                  <VideoComponent
                      :record="imageVideo"
                      :videoSize="'large'"
                      :fullSizeVideo="true">
                  </VideoComponent>
                </div>
              </div>
            </swiper-slide>

            <div v-if="getType(boardData.contents.files.contentType) === 'image'"
                 slot="pagination"
                 :class="boardData.contents && boardData.contents.files && boardData.contents.files.resourceUri && boardData.contents.files.length > 0 ? 'show-pagination' : 'hide-pagination'"
                 class="swiper-pagination"></div>
            <div v-else slot="pagination"
                 :class="boardData.contents.files.length > 1 ? 'show-pagination':'hide-pagination'"
                 class="swiper-pagination"></div>
            <div slot="button-prev" class="swiper-button-prev custom-nav custom-nav-transparent"
                 @click.stop
                 @keypress.stop>
              <i v-if="boardData.contents && boardData.contents.files && boardData.contents.files.resourceUri && boardData.contents.files.length > 0"
                 class="material-icons t-color-white rtl-support">keyboard_arrow_left</i>
              <i v-else-if="boardData.contents.files.length > 1"
                 class="material-icons t-color-white rtl-support">keyboard_arrow_left</i>
            </div>
            <div slot="button-next" class="swiper-button-next custom-nav custom-nav-transparent"
                 @click.stop
                 @keypress.stop>
              <i v-if="boardData.contents && boardData.contents.files && boardData.contents.files.resourceUri && boardData.contents.files.length > 0"
                 class="material-icons t-color-white rtl-support">keyboard_arrow_right</i>
              <i v-else-if="boardData.contents.files.length > 1"
                 class="material-icons t-color-white rtl-support">keyboard_arrow_right</i>
            </div>
          </swiper>

          <div v-if="!boardData.isBlocked && boardData.tags !== []" class="d-flex mgt-12 pdb-16 flex-wrap">
            <div
                v-for="(tag, index1) in boardData.tags"
                :key="index1"
                class="pdl-8 pdr-8 pdt-3 pdb-3 b-radius22 mgr-4 mgt-4 t-helper font-r t-color-contentBlue bg-contentBlueInactive">
              #{{ tag.name }}
            </div>
          </div>

          <!--            <div v-if="boardData && boardData.contents && boardData.contents.files" class="community-search-list" @click.stop>-->
          <!--              <div v-for="(file, i) in boardData.contents.files" :key="i">-->
          <!--                <div v-show="file.saveType.value === 'ATTACHED_FILE'">-->
          <!--                  <div class="pdl-16 pdr-16 pdt-7 pdb-6 bg-documentGray mgb-8 b-radius4">-->
          <!--                    <div class="d-flex align-items-center justify-content-between search-list ">-->
          <!--                      <div class="d-flex align-items-center flex-grow-1">-->
          <!--                        <i class="material-icons t-color-secondaryBtnText pdr-8 t-line-h-29 t-subtitle5">attach_file</i>-->
          <!--                        <a class="t-body3 font-r t-color-signBlue"-->
          <!--                           href="javascript:void(0)"-->
          <!--                           tabindex="0" @click="downloadFile(file.resourceUri, file.originalName, file.contentType)" @keypress="downloadFile(file.resourceUri, file.originalName, file.contentType)">{{-->
          <!--                            file.originalName-->
          <!--                          }}</a>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
        </div>

        <div class="divider" v-if="!boardData.isBlocked"></div>
        <div v-if="!boardData.isBlocked" class="d-flex justify-content-between pdt-14 pdl-24 pdr-24 pdb-14" tabindex="0" @click="moveToDetail(boardData.id)" @keypress="moveToDetail(boardData.id)">
          <div class="t-helper t-color-bodyGrayB font-r t-line-h-17">
            {{ $t("3118", {str: boardData ? boardData.commentCount : '0'}) }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {swiper, swiperSlide} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import {videoPlayer} from "vue-video-player";
import {fileMixin} from "@/mixins/file";
import localStorageUtil from "@/utils/localStorageUtil";
import {mediaTypeConstants} from "@/utils/enum/MediaTypeConstants";
import VideoComponent from "@/components/common/VideoComponent.vue";

export default {
  props: ['boardData', 'type'],

  name: "BoardComponent",

  mixins: [fileMixin],

  components: {
    swiper,
    swiperSlide,
    'video-player': videoPlayer,
    VideoComponent,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
},

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    isMediaFile() {
      return _.filter(this.boardData.contents.files, (file) => {
        return file.saveType.value === mediaTypeConstants.MEDIA_SAVE_TYPE.value;
      })
    }
  },

  data() {
    return {
      bgColorOfName: localStorageUtil.getBgColor(),
      imageHeight: 720,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 16,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        translate: 0,
        autoHeight: false,
      },
      imageSize: true,
      thumbnailUrl: require("@/images/blackBackground.jpg")
    }
  },

  mounted() {
    if (this.boardData) {
      this.$nextTick(() => {
        this.imageHeight = this.$refs.imageVideoRef && this.$refs.imageVideoRef[0].clientHeight;
      })
    }
  },

  methods: {
    firstCharOfMemberName(name) {
      if (name.first) {
        let fullName = this.$t('3437', {first: name.first, last: name.last});
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },

    // Go to detail page
    moveToDetail(postId) {
      this.$router.push({
        name: 'BoardView',
        params: {boardId: this.$route.params.boardId, postId: postId},
        query: this.$route.query
      })
    },
	  
	  contentsRemoveTag(str) {
		  return str.replace(/<img[^>]*>/gi, "").replace(/<a[^>]*>/gi, "").replace(/(\r\n|\n|\r)/gm, "");
	  },
  }
}

</script>

<style scoped>
.swiper-button-prev.custom-nav {
  background-image: none;
}

.swiper-button-next.custom-nav {
  background-image: none;
}

.video-js video {
  width: 100%;
  height: 100%;
}

.hide-pagination {
  visibility: hidden;
}

.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
  visibility: hidden !important;
}

.board-list-image {
  position: absolute;
  width: 100%;
  height: 100% !important;
}
.swiper-wrapper{
        align-items: center !important;
    }
</style>
<style lang="css" scoped src="../../css/bootstrap.css"></style>
<style lang="css" scoped src="../../css/editor.css"></style>
